import type { BaseAsyncProps } from "@dashboardApi/apis";
import getUuid from "uuid-by-string";

import { stableValueHash } from "./stableValueHash";

/**
 * Parameters that can be used to generate a job token.
 * This is like BaseAsyncProps but with jobToken made optional since the function generates it.
 */
type JobTokenOptionalAsyncProps = Omit<BaseAsyncProps, "jobToken"> & {
  jobToken?: string;
};

/**
 * Given a set of arguments to send to the server, generate a unique, reproducible UUID for a job token
 * @param params the parameters passed to a POSTWS fetcher function. These must have the same shape as BaseAsyncProps but jobToken is optional
 * @returns a unique job token string
 */
export const jobTokenFromParams = <Params extends JobTokenOptionalAsyncProps>(params: Params): string => {
  if (params.jobToken) {
    return params.jobToken;
  }
  const { jobToken, ...rest } = params;
  // this is the approach react-query uses to ensure that params with different ordering hash to the same query key, so we are stealing it
  const wellOrderedParams = stableValueHash(rest);
  return getUuid(wellOrderedParams);
};
